import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  signal,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgpCheckbox } from 'ng-primitives/checkbox';

@Component({
  selector: 'tc-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgpCheckbox],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  template: `
    <button
      type="button"
      ngpCheckbox
      class="peer inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-primary text-primary-foreground shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[checked]:bg-primary data-[checked]:text-primary-foreground data-[checked]:[&_i]:opacity-100"
      [ngpCheckboxChecked]="checked()"
      [ngpCheckboxDisabled]="isDisabled()"
      (ngpCheckboxCheckedChange)="onCheckedChange($event)"
    >
      <i class="ri-check-line text-xs opacity-0" aria-hidden="true"></i>
    </button>
  `,
  host: {
    class: 'inline-flex',
  },
})
export class CheckboxComponent implements ControlValueAccessor {
  readonly disabled = input(false, {
    transform: (v: boolean | string) => v === true || v === '',
  });

  protected readonly checked = signal(false);
  protected readonly isDisabled = signal(false);

  private onChange: (value: boolean) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: boolean | null): void {
    this.checked.set(!!value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled || this.disabled());
  }

  protected onCheckedChange(value: boolean): void {
    this.checked.set(value);
    this.onChange(value);
    this.onTouched();
  }
}
